/**
 * Helper for comparing two expressions with the given operator.
 *
 * @param {*} left Left part of the comparison
 * @param {string} operator Operator for the comparison
 * @param {*} right Right part of the comparison
 * @param {object} options Helper options
 * @param {string} [options.then] String to return when the comparison succeeds
 * @param {string} [options.else] String to return when the comparison fails
 * @returns {*}
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (left: any, operator: string, right: any, options: any): any {
  let result: any;

  switch (operator) {
    case '==':
      // tslint:disable-next-line:triple-equals
      result = (left == right);
      break;

    case '===':
      result = (left === right);
      break;

    case '!=':
      // tslint:disable-next-line:triple-equals
      result = (left != right);
      break;

    case '!==':
      result = (left !== right);
      break;

    case '<':
      result = (left < right);
      break;

    case '<=':
      result = (left <= right);
      break;

    case '>':
      result = (left > right);
      break;

    case '>=':
      result = (left >= right);
      break;

    case '&&':
      result = (left && right);
      break;

    case '||':
      result = (left || right);
      break;

    default:
      result = false;
  }

  if (options.hash.hasOwnProperty('then') || options.hash.hasOwnProperty('else')) {
    if (result) {
      if (options.hash.hasOwnProperty('then')) {
        return options.hash.then;
      }
      return null;
    } else {
      if (options.hash.hasOwnProperty('else')) {
        return options.hash.else;
      }
      return null;
    }
  } else {
    return result ? options.fn(this) : options.inverse(this);
  }
}
